<template>
	<van-popover v-model:show="showPopover" trigger="click" placement="bottom-end" class="tab-propover" :overlay="true"
		:offset="[6, 12]">
		<van-grid square clickable :border="false" :column-num="4" class="tab-list-wrap">
			<div v-for="tab in tabList" :key="tab.specialAreaId"
				:class="['tab-item', activeId === tab.specialAreaId ? 'active-tab' : '']" @click="clickTab(tab)">
				{{ tab.specialAreaName }}
			</div>
		</van-grid>
		<template #reference>
			<i class="iconfont icon-zhengxu"></i>
		</template>
	</van-popover>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
	activeId: {
		type: Number,
		default: -1,
	},
	tabList: {
		type: Array,
		default: () => [],
	},
});

const emit = defineEmits(['clickTab']);

const showPopover = ref(false);

function clickTab(tab) {
	const { specialAreaId, specialAreaName } = tab;
	emit('clickTab', specialAreaId, specialAreaName);
	showPopover.value = false;
}
</script>

<style lang="scss" scoped>
.icon-zhengxu {
	font-size: 16px;
	margin-left: 7px;
}

.tab-list-wrap {
	width: 360px;
	padding: 8px;
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 8px;
}

.tab-item {
	border-radius: 4px;
	line-height: 30px;
	padding: 0 7px;
	color: #333333;
	background: #f5f5f5;
	text-align: center;

	&.active-tab {
		color: #455bd9;
		background: #edf0ff;
	}
}

:deep(.van-popover__arrow) {
	right: 4px !important;
}
</style>

<style>
.van-popover[data-popper-placement='bottom-end'] .van-popover__arrow {
	right: 6px !important;
}
</style>
